/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import modalTypes from '../../constants/modalTypes.js';
import Modal from '../common/Modal';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as modalActions from '../../actions/modalActions';
import * as urlUtils from '../../utils/urlUtils';

const SpinnupDiscountCode = (props) => { 

    const showAlert = () => {
        props.actions.showModal(modalTypes.SPINNUP_DISCOUNT_CODE);
    };
    return (
        <div className="main">
            <MetaTags>       
                <title>Spinnup Discount Code - Free Single Release - Spotify, iTunes, Amazon</title>     
                <meta id="description" name="description" content="Spinnup is a music distribution service, currently offering a free single release for a limited time period." />   
            </MetaTags>
            <div className="container">
                <div className="block-inner">
                    <div className="row">
                        <div className="col-md-12">
                            <article className="body-copy minimal-height">
                                <header>
                                    <h1 className="section-alt">Spinnup Discount Code</h1>
                                </header>
                                <div className="body-narrow">
                                    <p style={{color:"#777"}}>Spinnup is a music distribution service owned by Universal Music. They enable you to sell your music online by getting it published to the major music distribution channels such as iTunes, Amazon, Google Play, Spotify, and more. What makes them unique though is their team of scouts who have links to Universal Music and Island Records (UK). Their scouts will listen to the music uploaded and provide feedback. Spinnup are currently offering a discount coupon for a <strong>free</strong> single release. <a href="/go/spinnup" className="transition" target="_blank" rel="nofollow" onClick={(e) => { showAlert(); urlUtils.logExternalLinkClick(e);}} style={{color:"blue"}}>Get the discount code</a> to apply at checkout for a free single release.</p>
                                    <br />
                                    Check out our <Link to="/RecommendedLinks">Recommended Links</Link> page for more recommendations.
                                    <br />
                                    <br />
                                    <Link to="/">Return to Homepage</Link>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
            <Modal headerText="Spinnup Discount Code" type={modalTypes.SPINNUP_DISCOUNT_CODE} buttonText="OK" small>
                <p>Enter discount code <strong>spinnaffiliate</strong> at checkout to get a free single release</p>
            </Modal>
        </div>
    );
};

SpinnupDiscountCode.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, modalActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpinnupDiscountCode);